import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../../assets/logo.png";
import { FaSyncAlt } from "react-icons/fa";
import { API_BASE_URL } from "../../../config";



export default function PoolCareBusinessFranchiseListings() {
  const navigate = useNavigate();
   const isMobile = window.innerWidth <= 768;
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  const routerLocation = useLocation();

const [filters, setFilters] = useState({
  category: "Pool Care",
  view: "business",
  state: "",
  postcode: "",
});

const options = {
  category: ["Lawn Mowing", "Cleaning", "Pool Care"],
  state: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"],
};

const selectStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "15px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "1rem",
};

  useEffect(() => {
    loadListings();
  }, []);

  const loadListings = async () => {
    try {
      const res = await axios.get(
       `${API_BASE_URL}/api/poolcare/business-franchise`
      );

      if (res.data?.success) {
        setListings(res.data.listings || []);
      }
    } catch (err) {
      console.error("❌ Failed to load pool care business listings", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: 30 }}>Loading listings…</div>;
  }

return (
<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row", // 👈 THIS LINE DOES THE MAGIC
    minHeight: "100vh",
    overflow: "hidden",
    backgroundColor: "#f4f7f9",
  }}
>

    {/* FIXED SIDEBAR */}
<aside
  style={{
    width: isMobile ? "100%" : "250px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: isMobile ? "6px 8px" : "20px",
    height: "100vh",
    overflowY: "auto",
    textAlign: "center",
  }}
>
  <img
    src={logo}
    alt="Client Exchange Logo"
    style={{ width: "140px", margin: "0 auto 25px" }}
  />

  <div style={{ marginTop: "20px", textAlign: "left" }}>

    <label style={{ fontWeight: "bold" }}>Category:</label>
    <select
      value={filters.category}
      onChange={(e) => {
        const category = e.target.value;
        setFilters({ ...filters, category });

        if (category === "Lawn Mowing") navigate("/listings");
        if (category === "Cleaning") navigate("/cleaning/listings");
        if (category === "Pool Care") navigate("/poolcare/businesses");
      }}
      style={selectStyle}
    >
      <option value="Lawn Mowing">Lawn Mowing</option>
      <option value="Cleaning">Cleaning</option>
      <option value="Pool Care">Pool Care</option>
    </select>

    <label style={{ fontWeight: "bold" }}>View:</label>
<select
  value={filters.view}
  onChange={(e) => {
    const view = e.target.value;
    setFilters({ ...filters, view });

    if (view === "business") {
      navigate("/poolcare/businesses");
    }

    if (view === "listings") {
      navigate("/poolcare/listings");
    }

    if (view === "swaps") {
      navigate("/poolcare/swaps");
    }
  }}
  style={selectStyle}
>
  <option value="business">Business</option>
  <option value="listings">Listings</option>
  <option value="swaps">Swaps</option>
</select>

    <label style={{ fontWeight: "bold" }}>State:</label>
    <select
      value={filters.state}
      onChange={(e) =>
        setFilters({ ...filters, state: e.target.value })
      }
      style={selectStyle}
    >
      <option value="">All</option>
      {options.state.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>

    <label style={{ fontWeight: "bold" }}>Postcode:</label>
    <input
      type="text"
      value={filters.postcode}
      onChange={(e) =>
        setFilters({ ...filters, postcode: e.target.value })
      }
      placeholder="Enter Postcode"
      style={selectStyle}
    />

    <button
      onClick={() =>
        setFilters({
          category: "Pool Care",
          view: "business",
          state: "",
          postcode: "",
        })
      }
      style={{
        width: "100%",
        padding: "12px",
        backgroundColor: "#d32f2f",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: "bold",
        marginTop: "10px",
      }}
    >
      <FaSyncAlt /> Reset Filters
    </button>

  </div>
</aside>

    {/* MAIN CONTENT */}
<main
  style={{
    flex: 1,
    padding: "20px",
    overflowY: "auto",
    height: "100vh",
  }}
>
      <h2 style={{ color: "#2e7d32", marginBottom: "20px" }}>
        Pool Care Businesses — {listings.length} Results
      </h2>

      {listings.length === 0 ? (
        <p>No listings available.</p>
      ) : (
        <div
          style={{
            display: "grid",
           gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "20px",
          }}
        >
          {listings.map((listing) => (
            <div
              key={listing.id}
              style={{
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                overflow: "hidden",
              }}
            >
              <img
                src="/images/poolcare.jpg"
                alt="Pool Care Business"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                }}
              />

            <div style={{ padding: "15px" }}>
  <h3>{listing.business_title}</h3>

  {/* LOCATION */}
  <div style={{ marginBottom: "8px", color: "#555", fontSize: "0.9rem" }}>
    📍 {listing.suburb || "Unknown Suburb"}, {listing.state || ""} {listing.postcode || ""}
  </div>

  <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
    Asking Price: $
    {Number(listing.price).toLocaleString()}
  </div>

                <button
                  style={{
                    width: "100%",
                    marginTop: "12px",
                    backgroundColor: "#2e7d32",
                    color: "#fff",
                    padding: "10px",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                  onClick={() =>
                    navigate(`/poolcare/businesses/${listing.id}`)
                  }
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </main>

  </div>
);
}
